import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  infoBox: {
    border: 0,
    width: '100%',
    top: 0,
    color: 'white',
    textAlign: 'center',
    padding: '5px 0',
    minHeight: 'auto',
    overflow: 'hidden'
  },

  infoParagraph: {
    margin: 0,
    width: '95%',
    float: 'left',
    '& a': {
      color: theme.palette.white_100.main,
      textDecoration: 'none'
    },
    '&:hover': {
      color: theme.palette.white_100.main,
      '& a': {
        color: theme.palette.white_100.main,
        textDecoration: 'underline'
      }
    }
  },
  announcementText: {
    marginRight: '4px'
  },

  Hellobox: {
    width: '20%',
    float: 'left',
    padding: 5,
    color: 'White'
  },
  infobutton: {
    backgroundColor: 'transparent',
    color: 'white',
    border: 0,
    width: '5%',
    height: '100%',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  visible: {
    display: 'none',
    height: 0,
    padding: 0,
    margin: 0,
    top: 0,
    overflow: 'hidden'
  }
}))
